import React from 'react'

// css
import 'assets/style/elements/text.scss'

function Element({ children, className = '', text, onClick = () => {}, style = {} }) {
  return (
    <>
      <span className={'common-text ' + className} style={style} onClick={onClick}>
        {text ?? children}
      </span>
    </>
  )
}

export default Element
